import { Component } from '@angular/core';
import { LogoColors } from './logo-colors.const';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
  mainColor = LogoColors.DEFAULT.mainColor;
  secondaryColor = LogoColors.DEFAULT.secondaryColor;

  constructor() {}
}
